class VideoElement extends HTMLElement {
  constructor() {
    super();
    /** @type {boolean} */ this.initialized = false;

    /** @type {HTMLButtonElement | null} */ this.playBtn = null;
    /** @type {HTMLButtonElement | null} */ this.pauseBtn = null;
    /** @type {HTMLElement | null} */ this.controls = null;

    /**
     * <deferred-media> host with optional APIs.
     * @type {(HTMLElement & { showDeferredMedia?:Function, playMedia?:Function, pauseMedia?:Function }) | null}
     */
    this.deferredMedia = null;

    /** @type {boolean} */ this.autoplay = false;
    /** @type {boolean} */ this.controlsHidden = false;
  }

  connectedCallback() {
    if (this.initialized) return;

    this.deferredMedia = this.closest('deferred-media');
    this.controls = this.querySelector('.video__controls');
    this.playBtn = this.querySelector('.video__control.play');
    this.pauseBtn = this.querySelector('.video__control.pause');

    if (!this.controls || !this.playBtn || !this.pauseBtn) return;

    this.autoplay = this.#boolAttr('video-autoplay');
    this.controlsHidden = this.#boolAttr('video-controls-hidden');

    this.playBtn.addEventListener('click', () => this.play());
    this.pauseBtn.addEventListener('click', () => this.pause());

    if (this.autoplay) {
      this.#toggleButtons({ playing: true });
    } else {
      this.#toggleButtons({ playing: false });
    }

    this.initialized = true;
  }

  play() {
    if (!this.deferredMedia) return;
    const mediaWasLoaded = this.deferredMedia.hasAttribute('data-media-loaded');

    if (!this.autoplay && !mediaWasLoaded) {
      this.deferredMedia.showDeferredMedia?.();
    } else {
      this.deferredMedia.playMedia?.();
    }

    // Hide if video controls are visible and not autoplay
    if (!this.autoplay && !this.controlsHidden) {
      this.#applyControlsVisibility(true);
    }

    this.#toggleButtons({ playing: true });
  }

  pause() {
    if (!this.deferredMedia) return;
    this.deferredMedia.pauseMedia?.();
    this.#toggleButtons({ playing: false });
  }

  /**
   * Utility: parse boolean-like attributes.
   * @param {string} name - Attribute name
   * @returns {boolean}
   */

  #boolAttr(name) {
    const v = this.getAttribute(name);
    if (v === '' || v === 'true' || v === '1') return true;
    return false;
  }

  /**
   * Show or hide the entire controls wrapper.
   * @param {boolean} hidden - Whether to hide controls
   */
  #applyControlsVisibility(hidden) {
    if (this.controls) this.controls.hidden = !!hidden;
  }

  /**
   * Toggle visibility of play/pause buttons.
   * @param {{ playing: boolean }} payload - Object with playback state
   */
  #toggleButtons({ playing }) {
    if (!this.playBtn || !this.pauseBtn) return;

    if (playing) {
      this.playBtn.hidden = true;
      this.pauseBtn.hidden = false;
    } else {
      this.playBtn.hidden = false;
      this.pauseBtn.hidden = true;
    }
  }
}

customElements.define('video-element', VideoElement);
